import { defineMessages } from "react-intl";
/**
 * Translate properties of each element in the list from translation-key to translation-value
 * if the property exist in the element of the list and the value is the same as translation-key
 * @param translation
 * @param list
 * @param getQualifyingValue extract translation candidate
 * @param setRelevantValue update relevant element with new value
 */
function translateListAdvanced(translation, list, getQualifyingValue, setRelevantValue) {
    if (list == null)
        return [];
    return list.map(element => {
        const val = getQualifyingValue(element);
        const translatedValue = val != null ? translation[val] : null;
        if (translatedValue) {
            element = setRelevantValue(element, translatedValue);
        }
        return element;
    });
}
/**
 * Translate properties of each element in the list from translation-key to translation-value
 * if the property exist in the element of the list and the value is the same as translation-key
 * @param translation
 * @param list
 * @param propertyName
 */
function translateList(translation, list, propertyName) {
    return translateListAdvanced(translation, list, e => e[propertyName], (e, newValue) => ({ ...e, [propertyName]: newValue }));
}
const translateFieldLabel = (translation, panel) => {
    const newSections = panel?.sections?.map(section => ({
        ...section,
        fields: translateList(translation, section.fields ?? [], "label")
    }));
    return { ...panel, sections: newSections };
};
const translateGroup = (translation, panel) => {
    const newSections = translateListAdvanced(translation, panel?.sections ?? [], e => e.expansionTitle ?? e.group, (e, newValue) => ({ ...e, expansionTitle: newValue }));
    return { ...panel, sections: newSections };
};
const translateTabGroup = (translation, panel) => {
    if (panel?.sections === null)
        return panel;
    const newSections = translateList(translation, panel?.sections ?? [], "tabGroup");
    return { ...panel, sections: newSections };
};
export const translateSideBar = (intl, sidebar) => {
    const translation = {
        Summary: intl.formatMessage(messages.summary),
        PaymentPlanSection: intl.formatMessage(messages.paymentplansection)
    };
    sidebar = translateTabGroup(translation, sidebar);
    return sidebar;
};
export const translateSummary = (intl, summary) => {
    const translation = {
        Summary: intl.formatMessage(messages.summary),
        PaymentPlanSection: intl.formatMessage(messages.paymentplansection)
    };
    summary = translateTabGroup(translation, summary);
    return summary;
};
export const translateMain = (intl, main) => {
    const translation = {
        Summary: intl.formatMessage(messages.summary),
        Commission: intl.formatMessage(messages.commissionsection),
        DocumentUploadSection: intl.formatMessage(messages.documentuploadsection),
        Cosigner: intl.formatMessage(messages.cosignersection),
        Signing: intl.formatMessage(messages.signingsection),
        Fulfillment: intl.formatMessage(messages.fulfillmentsection),
        Refinancing: intl.formatMessage(messages.refinancingsection),
        InputFields: intl.formatMessage(messages.inputfieldssection),
        IncomeExpenses: intl.formatMessage(messages.incomeexpensessection),
        Comments: intl.formatMessage(messages.commentsSection)
    };
    main = translateGroup(translation, main);
    return main;
};
export const translateSidebarActions = (intl, sidebarAction) => {
    const translation = {
        CalculatorContinue: intl.formatMessage(messages.calculatorcontinue)
    };
    sidebarAction = translateFieldLabel(translation, sidebarAction);
    return sidebarAction;
};
const messages = defineMessages({
    summary: {
        id: "form.sidebar.tab.summary",
        description: "Title of summary tab",
        defaultMessage: "Summary"
    },
    paymentplansection: {
        id: "form.sidebar.tab.paymentplan",
        description: "Title of paymentplansection",
        defaultMessage: "Payment plan"
    },
    commissionsection: {
        id: "form.summary.commission",
        description: "Provision summary section expansionGroup",
        defaultMessage: "Commissions"
    },
    documentuploadsection: {
        id: "form.summary.documentupload",
        description: "Document upload section expansionGroup",
        defaultMessage: "Document uploading"
    },
    cosignersection: {
        id: "form.summary.cosigner",
        description: "Cosigner section expansionGroup",
        defaultMessage: "Co-applicant"
    },
    signingsection: {
        id: "form.summary.signing",
        description: "Signing section expansionGroup",
        defaultMessage: "Signing"
    },
    fulfillmentsection: {
        id: "form.summary.fulfillment",
        description: "Fulfillment section expansionGroup",
        defaultMessage: "Fulfillment"
    },
    refinancingsection: {
        id: "form.summary.refinancing",
        description: "Refinancing section expansionGroup",
        defaultMessage: "Refinancing"
    },
    inputfieldssection: {
        id: "form.summary.inputfields",
        description: "Inputfields section expansionGroup",
        defaultMessage: "Additional information"
    },
    incomeexpensessection: {
        id: "form.summary.incomeexpenses",
        description: "Income expenses section expansionGroup",
        defaultMessage: "Income"
    },
    commentsSection: {
        id: "form.summary.comments",
        description: "Comments section group",
        defaultMessage: "Comments"
    },
    calculatorcontinue: {
        id: "dealer.applications.actions.new-application.label",
        description: "Label for continue button in calculator",
        defaultMessage: "New application"
    }
});
//# sourceMappingURL=translateSection.js.map